import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { FinancialWorkspace } from '../FinancialWorkspace'
import { useFinancialWorkspaceAvailabilities } from '../FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import { InsightTableGroupBy, InsightTableType } from '../FinancialWorkspace/types/table'
import { PermissionsProvider } from '../FinancialWorkspaceEmployeeCosts/Providers/PermissionsProvider'
import { useFilters } from './components/Filters/useFilters'
import { Header } from './components/Header'
import { PayrollLanding } from './components/Landing'
import { useTableProps } from './components/Table/props'
import { PayrollChart } from './components/chart'

const FinancialWorkspacePayroll = ({
  authorized,
  seePayrollLanding,
}: {
  authorized: boolean
  useCompensation?: boolean
  seePayrollLanding: boolean
}) => {
  const availabilities = useFinancialWorkspaceAvailabilities()
  const tableProps = useTableProps()

  return (
    <ResponsivePage.Body authorized={authorized} showHeader={false} variant="full">
      <PermissionsProvider>
        <FinancialWorkspace
          tableProps={tableProps}
          chart={<PayrollChart />}
          additionalFilters={useFilters}
          insightTableType={InsightTableType.Payroll}
          defaultGroupBy={InsightTableGroupBy.LineItem}
          header={<Header availabilities={availabilities} />}
          renderLandingBanner={
            seePayrollLanding ? () => <PayrollLanding availabilities={availabilities} /> : undefined
          }
        />
        <Outlet context={{ canSeeFinanceWorkspace: authorized }} />
      </PermissionsProvider>
    </ResponsivePage.Body>
  )
}

export default FinancialWorkspacePayroll
